import VaffColorField from './VaffColorField.js';
import VaffDurationField from './VaffDurationField.js';
import VaffMediaField from './VaffMediaField/index.js';

export default {
	vaffColorField: VaffColorField,
	vaffDurationField: VaffDurationField,
	vaffMediaField: VaffMediaField,
};
